import {Application} from "stimulus";
// @ts-expect-error - esbuild-resolved stimulus loader
import {definitions as controllers} from "stimulus:./controllers";
// @ts-expect-error - esbuild-resolved stimulus loader
import {definitions as baseComponentControllers} from "stimulus:../../../app/components";
// @ts-expect-error - esbuild-resolved stimulus loader
import {definitions as mountComponentControllers} from "stimulus:../../../app/mounts/lighthouse/components";

const application = Application.start();
application.load(controllers);
application.load(baseComponentControllers);
application.load(mountComponentControllers);

import ClipboardController from "../../../frontend/src/controllers/clipboard_controller";
application.register("clipboard", ClipboardController);

import DisableAttachmentsController from "../../../frontend/src/controllers/disable_attachments_controller";
application.register("disable-attachments", DisableAttachmentsController);

import DebounceController from "src/admin/controllers/debounce_controller";
application.register("debounce", DebounceController);

import PrefillInputController from "src/controllers/prefill_input_controller";
application.register("prefill-input", PrefillInputController);

import AutocompleteAddressController from "src/controllers/autocomplete_address_controller";
application.register("autocomplete-address", AutocompleteAddressController);

import AddableNestedAttributesController from "../../../app/mounts/admin/components/admin/addable_nested_attributes_controller";
application.register("admin--addable-nested-attributes", AddableNestedAttributesController);

import RemovableNestedAttributesController from "../../../app/mounts/admin/components/admin/removable_nested_attributes_controller";
application.register("admin--removable-nested-attributes", RemovableNestedAttributesController);

import FilterableListController from "../../../frontend/src/admin/controllers/filterable_list_controller";
application.register("admin--filterable-list", FilterableListController);

import FilterableSelectController from "../../../frontend/src/admin/controllers/filterable_select_controller";
application.register("admin--filterable-select", FilterableSelectController);

import SubmitFormController from "../../../frontend/src/admin/controllers/submit_form_controller";
application.register("admin--submit-form", SubmitFormController);

import TabsController from "src/admin/controllers/tabs_controller";
application.register("tabs", TabsController);

import ConfirmAbandonFormController from "src/admin/controllers/confirm_abandon_form_controller";
application.register("admin--confirm-abandon-form", ConfirmAbandonFormController);

import WithPopoverController from "../../../app/mounts/admin/components/admin/with_popover_controller";
application.register("admin--with-popover", WithPopoverController);

import WithTooltipController from "../../../app/mounts/admin/components/admin/with_tooltip_controller";
application.register("admin--with-tooltip", WithTooltipController);

import AdminModalController from "../../../app/mounts/admin/components/admin/modal/modal_controller";
application.register("admin--modal--modal", AdminModalController);

import AdminModalOpenController from "../../../app/mounts/admin/components/admin/modal/open_controller";
application.register("admin--modal--open", AdminModalOpenController);

import AdminFormInputFilterableSelectController from "../../../app/mounts/admin/components/admin/form/input/filterable_select_controller";
application.register("admin--form--input--filterable-select", AdminFormInputFilterableSelectController);

import AdminFormInputDateController from "../../../app/mounts/admin/components/admin/form/input/date_controller";
application.register("admin--form--input--date", AdminFormInputDateController);

import FormInputTagsController from "../../../app/mounts/admin/components/admin/form/input/tags_controller";
application.register("admin--form--input--tags", FormInputTagsController);

import DismissablePanelController from "../../../app/mounts/admin/components/admin/dismissable_panel_controller";
application.register("admin--dismissable-panel", DismissablePanelController);

import FinalHCPClaimUnlockedController from "../../../app/mounts/admin/components/admin/final_hcp_claim_unlocked_controller";
application.register("admin--final-hcp-claim-unlocked", FinalHCPClaimUnlockedController);

import AddCredentialsController from "../lighthouse/controllers/add_credential_controller";
application.register("lighthouse--add-webauthn-credential", AddCredentialsController);

import ListFilterController from "../lighthouse/controllers/list_filter_controller";
application.register("lighthouse--list-filter", ListFilterController);

import CommentEditorController from "../lighthouse/controllers/comment_editor_controller";
application.register("lighthouse--data-dictionary--comment-editor", CommentEditorController);

import CredentiaAuthenticatorController from "../lighthouse/controllers/credential_authenticator_controller";
application.register("lighthouse--webauthn-credential-authenticator", CredentiaAuthenticatorController);

import PromptPreviewController from "../lighthouse/controllers/prompt_preview_controller";
application.register("lighthouse--prompt-preview", PromptPreviewController);

import {MarksmithController} from "@avo-hq/marksmith";
application.register("marksmith", MarksmithController);

import FormController from "../lighthouse/controllers/form_controller";
application.register("lighthouse--form", FormController);
